import { onMounted, onUnmounted, watch } from "vue";
import {
  WebHaptics,
  type HapticInput,
  type TriggerOptions,
  type WebHapticsOptions,
} from "web-haptics";
import { useHapticsContext } from "./context";
import type { UseWebHapticsReturn } from "./types";

export { HAPTICS_KEY } from "./context";
export type { HapticsContext, UseWebHapticsReturn } from "./types";

export const useWebHaptics = (
  options?: WebHapticsOptions,
): UseWebHapticsReturn => {
  const { isEnabled } = useHapticsContext();

  let instance: WebHaptics | null = null;

  onMounted(() => {
    instance = new WebHaptics(options);
  });

  onUnmounted(() => {
    instance?.destroy();
    instance = null;
  });

  watch(
    () => options?.debug,
    (value) => {
      instance?.setDebug(value ?? false);
    },
  );

  const triggerHaptic = (
    input?: HapticInput,
    triggerOptions?: TriggerOptions,
  ): void => {
    if (!isEnabled.value) {
      return;
    }

    instance?.trigger(input, triggerOptions);
  };

  return {
    triggerHaptic,
    isSupported: WebHaptics.isSupported,
    isEnabled,
  };
};
